import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Typography } from '@mui/material';
import { DotsLoader } from '../spinners/dotsLoader/DotsLoader';
import usePriceFormatter from '../../hooks/usePriceFormatter';
import { usePlatformConfig } from '../../hooks/usePlatformConfig';
import { PriceDisplayType } from '../../enums/PriceDisplayType';
export const Price = memo(({ price, currency, decimals = 0, priceDisplayType, useCurrencySign = true, loading, taxLabel, ...rest }) => {
    const { platformConfig: { priceDisplay }, } = usePlatformConfig();
    const { currency: displayCurrency, decimalScale = 0, subunitToUnit = 100, } = priceDisplay[priceDisplayType || PriceDisplayType.PRIMARY_OPTIONS] || {};
    const priceFormatter = usePriceFormatter({
        currency: currency || displayCurrency,
        decimals: decimalScale || decimals,
        useCurrencySign,
    });
    if (!(currency || displayCurrency)) {
        return null;
    }
    if (loading) {
        return _jsx(DotsLoader, { dataTest: 'price:loader' }, void 0);
    }
    return (_jsxs(Typography, { ...rest, component: "span", children: [priceFormatter.format(price / subunitToUnit), " ", taxLabel] }, void 0));
});
//# sourceMappingURL=Price.js.map